import { Box } from "@mui/material";
import React from "react";

const CalendarLoader = () => {
  return (
    <Box padding="200px 100px" display="flex" alignItems="center" justifyContent="center">
      <span className="loader"></span>
    </Box>
  );
};

export default CalendarLoader;
